module.exports = __webpack_public_path__ + "static/media/u30_premium_contract1.70d8da2a.webp";